export * from './post-besichtigung.component';
export * from './post-besichtigung.component.module';